"use strict";

interface EasingFunction {
  (t: number, b: number, c: number, d: number): number;
}
interface AnimationUpdateCallback {
  (value: number): void;
}

const animate = (from: number, to: number, duration: number, update: AnimationUpdateCallback, done?: () => void) => {
  const easings: { [key: string]: EasingFunction } = {};
  let easing: any = null;

  easings.linear = (t, b, c, d) => {
    return (c * t) / d + b;
  };

  easing = easings.linear;

  if (
    typeof from !== "number" ||
    typeof to !== "number" ||
    typeof duration !== "number" ||
    typeof update !== "function"
  ) {
    return;
  }

  if (typeof done !== "function") {
    done = () => {};
  }

  const rAF =
    window.requestAnimationFrame ||
    ((callback: FrameRequestCallback) => {
      window.setTimeout(callback, 1000 / 50);
    });

  const change = to - from;

  function loop(timestamp: number) {
    const time = (timestamp || +new Date()) - start;

    if (time >= 0) {
      update(easing(time, from, change, duration));
    }
    if (time >= 0 && time >= duration) {
      update(to);
      if (done) {
        done();
      } // Asserting done exists
    } else {
      rAF(loop);
    }
  }

  update(from);

  const start = window.performance && window.performance.now ? window.performance.now() : +new Date();

  rAF(loop);
};

const scrollTo = (offsetValue: number, duration: number = 0) => {
  let scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  let from: any = 0,
    to: any = 0;

  if (offsetValue) {
    scrollPos += offsetValue;
  }

  from = scrollPos;
  to = 0;
  animate(
    from,
    to,
    duration,
    (value) => {
      document.documentElement.scrollTop = value;
      document.body.scrollTop = value;
    },
    () => {}
  );
};

const scrollTop = (offsetValue: number, duration: number) => {
  scrollTo(offsetValue, duration);
};

export { animate, scrollTo, scrollTop };
